'use client';

import { useRef } from 'react';
import type { ReactNode } from 'react';

/**
 * Section shell for the pricing page. The page sits on the normal
 * document-anchored body grid; GridGlow's center-column wash fades the grid
 * lines where content lives, so no GridClearing is needed. The content
 * column derives its width from the grid variables so it stays aligned with
 * the Navbar/Footer content band. `data-grid-block` markers in children are
 * inert; they're kept so clearings could be enabled without re-annotating.
 */
export default function GridSection({
  id,
  className = 'py-[118px]',
  background,
  children,
}: {
  id?: string;
  className?: string;
  /** Full-bleed decoration layer painted behind the content column. */
  background?: ReactNode;
  children: ReactNode;
}) {
  const rootRef = useRef<HTMLDivElement>(null);

  return (
    <section id={id} className={`relative ${className}`}>
      {background}
      <div
        ref={rootRef}
        className="relative mx-auto w-full max-w-[1200px] px-7 md:max-w-full md:px-0 md:w-[calc(var(--grid-container-width,1224px)_-_var(--grid-cell,72px))]"
      >
        <div className="relative z-10">{children}</div>
      </div>
    </section>
  );
}
